<template>
    <div class="link-codemirror" :class="{'link-codemirror-readonly':readonly}">
        <div ref="target" class="link-codemirror-target"></div>
    </div>
</template>

<script>
    import {CMUtils} from "./index";

    export default {
        name: "link-codemirror",
        props: {
            merge: {type: Boolean},                                 //是否为合并模式
            origin: {type: String},                                 //合并模式下右边源文件文本
            value: {type: String},                                  //可编辑文本
            mode: {type: String, default: 'java'},                  //文本高亮模式
            readonly: {type: Boolean},                              //是否只读
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    if (val !== this.p_value) {
                        this.p_value = val || ''
                        !!this.editor && this.editor.setValue(this.p_value)
                    }
                },
            },
            readonly: {
                immediate: true,
                handler(val) {
                    !!this.editor && this.editor.setOption('readOnly', val)
                },
            },
        },
        data() {
            return {
                cm: null,
                editor: null,

                p_value: this.value || '',
                p_origin: this.origin || '',

                publicOption: {
                    lineNumbers: true,
                    styleActiveLine: true,
                    mode: !!CMUtils.modeMap[this.mode] ? CMUtils.modeMap[this.mode] : this.mode,
                    selectionPointer: true,
                    highlightDifferences: true,
                    connect: true,
                    revertButtons: true,
                    indentUnit: 4,
                    theme: 'monokai',
                    readOnly: this.readonly,
                }
            }
        },
        async mounted() {
            if (!!this.merge) {
                this.pl_initMergeEditor()
            } else {
                this.pl_initSimpleEditor()
            }
        },
        methods: {
            async pl_initEvent() {
                this.editor.on('change', () => {
                    this.p_value = this.editor.getValue()
                    this.$emit('input', this.p_value)
                })
                this.editor.on('keydown', (cm, e) => this.$emit('keydown', e))
            },
            /**
             * 初始化simple编辑器
             * @author  韦胜健
             * @date    2019/9/9 10:26
             */
            async pl_initSimpleEditor() {
                const CodeMirror = await CMUtils.getCodeMirror()
                await CMUtils.loadPublicResource()
                this.cm = CodeMirror(this.$refs.target, {
                    value: this.value || '',
                    ...this.publicOption,
                })
                this.editor = this.cm
                this.pl_initEvent()
            },
            /**
             * 初始化merge编辑器
             * @author  韦胜健
             * @date    2019/9/9 10:27
             */
            async pl_initMergeEditor() {
                const CodeMirror = await CMUtils.getCodeMirror()
                await CMUtils.loadPublicResource()
                await CMUtils.loadResource([
                    'codemirror/addon/merge/merge.css',
                    'codemirror/diff_match_patch.js',
                    'codemirror/addon/merge/merge.js',
                ])
                this.cm = CodeMirror.MergeView(this.$refs.target, {
                    value: this.value || '',
                    origRight: this.origin || '',
                    orig: this.origin || '',
                    ...this.publicOption,
                })

                this.editor = this.cm.editor()
                this.pl_initEvent()
            },
        }

    }
</script>

<style lang="scss">
    .link-codemirror {
        height: 100%;
        width: 100%;

        .CodeMirror {
            font-family: source-code-pro, Menlo, Monaco, Consolas, Courier New, monospace !important;
            font-size: 14px;
            line-height: 1.5em;
        }

        .link-codemirror-target, .CodeMirror, .CodeMirror-merge, .CodeMirror-merge-pane {
            &, & > .CodeMirror {
                height: 100%;
                width: 100%;
            }
        }

        .CodeMirror-merge-r-chunk {
            background-color: rgba(255, 6, 0, 0.16);
            border: none;
        }

        &.link-codemirror-readonly {
            .CodeMirror-merge-copy {
                display: none !important;
            }
        }
    }
</style>
